export const ICON_SIZE = {
    xs: 'xxs',
    sm: 'xs',
    md: 'sm',
    lg: 'md',
    xl: 'md',
};
